export default `# Welcome to Spectrum

Spectrum is a collaborative platform for running structured sessions with AI avatars, capturing insights, and building a knowledge graph of your research.

---

## Key Concepts

### Projects
Projects are the top-level container for all your work. Each project brings together sessions, a knowledge graph, requirements, and integrations like Miro boards. [Learn more](help:projects)

### Sessions
Sessions are live, facilitated discussions with AI avatars. During a session you can:
- Have AI avatars contribute perspectives based on their personas
- Capture user stories, decisions, and pain points
- Run research tasks, feasibility debates, and competitive analyses
- Generate architecture diagrams and build artefacts

[Learn about creating sessions](help:session-creator)

### Knowledge Graph
The project graph connects all entities from your sessions — personas, user stories, decisions, and more — into a visual network. This helps you see relationships and patterns across sessions.

### Templates
Session templates define the structure and phases of a session. Admins can create reusable templates that teams use when starting new sessions. [Browse templates](help:templates-catalog)

### Avatars
AI personas with configurable expertise, personality, and voice. Avatars participate in sessions, offering perspectives based on their role and knowledge base. [Manage avatars](help:avatars-catalog)

---

## Navigation

- **[Projects](help:projects)** — View and manage all projects
- **[Sessions](help:session-creator)** — Create live sessions
- **[Templates](help:templates-catalog)** — Browse and create session templates
- **[Avatars](help:avatars-catalog)** — Manage AI avatar personas
- **[Teams](help:teams)** — Manage collaboration teams
- **[Build with AI](help:build-with-ai)** — Generate code from session insights

---

## During a Session

The session interface has a sidebar with panels organised into groups:

**Session** — [Dashboard](help:session-dashboard) | [Transcript](help:session-transcript) | [Avatars](help:session-avatars) | [Contributions](help:session-contributions)

**Insights** — [Guidance](help:session-guidance) | [Requirements](help:session-requirements) | [Decisions](help:session-decisions) | [Governance](help:session-governance)

**Tools** — [Tasks](help:session-tasks) | [Devices](help:session-devices) | [Second Screen](help:session-second-screen) | [Meetings](help:session-meetings) | [Miro Board](help:session-miro)

---

**Need help with a specific feature?** Browse the topics below, or open help from any page to see context-relevant guidance.`;
